import { mapGetters, mapActions } from 'vuex';

import { bindValidatorToForm, destroyValidator, processErrors, resetValidator } from '_/services/formValidator';

export default {
    /**
     * Set the component's data storage
     *
     * @return  {void}
     */
    data: function () {
        return {
            credentials: {},
            redirectPath: '/',
            validator: null,
            serverError: null,
        };
    },

    /**
     * Set the computed properties
     *
     * @type {object}
     */
    computed: {
        ...mapGetters({
            ui: 'ui/ui',
            user: 'user/user',
        }),
    },

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        ...mapActions('user', [
            // Map actions from user module namespace
            'clearAuthErrors',
            'login',
        ]),

        onSubmit() {
            this.redirectPath = this.$route.path;

            this.validator = bindValidatorToForm(
                {
                    selector: '#login-form',

                    onSubmit: () => {
                        this.clearAuthErrors();

                        this.login({
                            payload: this.credentials,
                            redirectPath: this.redirectPath,
                        }).then(() => {
                            window.location.reload();
                        });
                    },
                },
                this
            );
        },
    },

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted: function () {
        this.$nextTick(function () {
            this.credentials.email = this.user.meta.email;
        });
    },

    /**
     * Call a beforeDestroy hook
     *
     * @type  {function}
     * @return  void
     */
    beforeDestroy: function () {
        this.clearAuthErrors();

        destroyValidator(this.validator);
    },

    /**
     * Set the watched expressions
     *
     * @type  {Object}
     */
    watch: {
        'user.error.message': function () {
            this.$nextTick(() => {
                resetValidator(this.validator);

                this.serverError = processErrors(this.validator, this.user.error);
            });
        },
    },
};
